import { BereavedPerson, Bereavement } from 'types/ts/bereavement';

export const getBereavementBillPayer = (bereavement: Bereavement): BereavedPerson|null|undefined => {
  const { bereavedPeopleConnections } = bereavement || {};

  return bereavedPeopleConnections
    ?.find(bereavedPersonConnection => bereavedPersonConnection.isBillPayer)?.bereavedPerson;
};
